/** Prima por día libre trabajado: pago base + 130% del pago base (= x2.3). */
export const FREE_DAY_WORKED_PREMIUM_RATE = 1.3;

/** Prima turno doble: 30% de un salario diario (ej. 315 → +94.50). */
export const DOUBLE_SHIFT_DAILY_PREMIUM_RATE = 0.3;

/** Prima vacaciones: 25% sobre un salario diario (ej. 315 → 393.75). */
export const VACATION_DAILY_PREMIUM_RATE = 0.25;

export function calculateVacationPay(dailySalary: number): number {
  return dailySalary + dailySalary * VACATION_DAILY_PREMIUM_RATE;
}

/** 2 jornadas + 30% de un salario diario; opcional + horas extra después del umbral doble. */
export function calculateDoubleShiftPay(
  dailySalary: number,
  extraHoursBeyondThreshold = 0,
  hourlyPay = 0,
): number {
  return (
    dailySalary * 2 +
    dailySalary * DOUBLE_SHIFT_DAILY_PREMIUM_RATE +
    extraHoursBeyondThreshold * hourlyPay
  );
}

export function withFreeDayWorkedPremium(basePay: number): number {
  return basePay + basePay * FREE_DAY_WORKED_PREMIUM_RATE;
}

/** Si ya hay incidencia aceptada de día libre trabajado, el pago base ya incluye la prima en calculateDailyPayment. */
export function hasAcceptedFreeDayWorkedIncident(
  incidents: any[] | undefined | null
): boolean {
  return (incidents || []).some(
    (i: any) =>
      i?.finalStatus === true &&
      (i?.isFreeDayWorked === true || i?.status === "Día libre gozado")
  );
}
